import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from '@tq/ui-components';

import { useConsultation } from 'api';
import { useParams } from 'react-router-dom';
import { PageHeading } from 'components';
import { ArchivedConsultationButtons, OpenConsultationButtons } from '..';

export const SummaryHeader: React.FC = () => {
  const { t } = useTranslation('summary_header');
  const { id } = useParams();
  const { data: consultation } = useConsultation(+(id ?? 0));

  return (
    <Flex
      flexDirection={{ base: 'column', lg: 'row' }}
      justifyContent={{ base: 'unset', lg: 'space-between' }}
      gridGap={4}
    >
      <PageHeading
        heading={
          consultation?.isArchived
            ? t('consultation_summary_archived', 'Consultation summary (Archived)')
            : t('consultation_summary', 'Consultation summary')
        }
      />
      {consultation &&
        (consultation?.isArchived ? (
          <ArchivedConsultationButtons consultation={consultation} />
        ) : (
          <OpenConsultationButtons consultation={consultation} />
        ))}
    </Flex>
  );
};
